/**
 *
 *  ThemeProvider
 *  Provider
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useMemo } from "react";
import PropTypes from "prop-types";

// import { breakpoints } from "../../constants";

export const ThemeContext = React.createContext(null);

export const ThemeProvider = ({ children, theme }) => {
  var localTheme = useMemo(() => {
    return theme;
  }, [theme]);

  return (
    <ThemeContext.Provider
      value={{
        theme: {
          responsive: {
            breakpoints: Object.keys(localTheme.screens).reduce((acc, key) => {
              acc[key] = parseInt(localTheme.screens[key]);

              return acc;
            }, {}),
          },
          ...localTheme,
        },
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default ThemeProvider;
